import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import Recommendations from "../patientInit/pgx/Recommendations";
import ReactDOM from "react-dom";
import PatientGeneRow from "./PatientGeneRow";
import PhenoGenotype from "../patientInit/pgx/PhenoGenotype";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";

const PatientGenes = ({
                        patGenes,
                        setPatGenes,
                        init,
                        printView = false,
                        patientId,
                        deleteVisible}) => {
  const { t: t } = useTranslation();
  const [geneElems, setGeneElems] = useState([]);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [currentGene, setCurrentGene] = useState(null);
  const [risk, setRisk] = useState(null);
  const [riskGene, setRiskGene] = useState(null);
  const [allGenes, setAllGenes] = useState([]);
  const context = useContext(InitContext);
  const { loading, error, clearError, getDpwgJson, deleteDbGene, getDbGenes } = useMmcService();

  useEffect(() => {
    if (context?.token){
      clearError();
      getDpwgJson(context?.token).then((data) => setAllGenes(data));
    }
  }, [context?.token, clearError]);

  useEffect(() => {
    if(patGenes === null || patGenes?.length === 0){
      getDbGenes(context?.token, patientId).then((genesInDb) => {
        buildGeneElems(genesInDb);

        if(!init){
          setPatGenes(genesInDb);
        }
      });
    } else {
      buildGeneElems(patGenes);
    }
  }, [patGenes]);

  const buildGeneElems = (genes) => {
    setGeneElems(genes
      ?
      genes?.map((gene, i) => {
        return (
          <PatientGeneRow
            number={i}
            key={`gene${i * genes?.length}`}
            gene={gene}
            handleDrugClick={handleDrugClick}
            handleGeneDetails={handleGeneDetails}
            init={init}
            printView={printView}
            onDeleteGene={handleDeleteGene}
            deleteVisible={deleteVisible}
          />
        );
      })
      :
      []
    );
  }

  const handleDrugClick = (currentRisk, gene) => {
    setRisk(currentRisk);
    setRiskGene(gene);
  };

  const handleGeneDetails = (gene) => {
    if(!gene?.id){
      const filteredGenes = patGenes?.filter(
        (g) => g.geneName === gene?.geneName,
      );

      if (filteredGenes?.length > 0) {
        setCurrentGene(filteredGenes[0]);
        setOpenDetailsDialog((prev) => !prev);
      }
    }
  };

  const handleSetGene = (gene) => {
    setOpenDetailsDialog(false);

    if (!gene) {
      return;
    }

    const tempGenes = patGenes?.map((g) =>
      g.geneName === gene?.geneName ? gene : g,
    );

    setPatGenes(tempGenes);
    setCurrentGene(null);
  };

  const handleDeleteGene = async (gene) => {
    clearError();

    deleteDbGene(context?.token, gene?.id, patientId).then(() => {
      clearError();

      getDbGenes(context?.token, patientId).then((genesInDb) => {
        buildGeneElems(genesInDb);
        setPatGenes(genesInDb);
      });
    });
  }

  const elementId = init ? "patient-init" : "pgx-parent";

  const errorMessage = error && (
    <ErrorMessage message={t("error_by_retrieving_dpwg")} />
  );

  const spinner = !printView && loading && <Spinner />;

  return (
    <>
      {risk &&
        ReactDOM.createPortal(
          <Recommendations
            risk={risk}
            setRisk={setRisk}
            showDialog={risk}
            gene={riskGene}
          />,
          document.getElementById(elementId),
        )}
      {errorMessage}
      {spinner}
      {openDetailsDialog && currentGene && (
        <div>
          {ReactDOM.createPortal(
            <PhenoGenotype
              gene={currentGene}
              allGenes={allGenes}
              onSetGene={handleSetGene}
            />,
            document.getElementById(elementId),
          )}
        </div>
      )}
      {geneElems?.length > 0 && (
        <div
          className={
            init
              ? "w3-container w3-padding-small genes-content-scroll"
              : printView
                ? "w3-container w3-padding-small"
                : "w3-container w3-padding-small genes-content-scroll"
          }
        >
          <div className="w3-row w3-border-bottom w3-border-blue row-header">
            <div className="w3-col s2 w3-mobile">
              <label>{t(/** @type {any} */ "gene")}</label>
            </div>
            <div className="w3-col s2 w3-mobile">
              <label>{t(/** @type {any} */ "genotype")}</label>
            </div>
            <div className="w3-col s3 w3-mobile">
              <label>{t(/** @type {any} */ "phenotype")}</label>
            </div>
            <div className="w3-col s5 w3-mobile">
              <label>
                {t(/** @type {any} */ "critical_medicines_and_recommendations")}
              </label>
            </div>
          </div>
          {geneElems}
        </div>
      )}
    </>
  );
};

export default PatientGenes;
